const getters = {
	device: (state: any) => state.app.device,
	theme: (state: any) => state.app.theme,
	color: (state: any) => state.app.color,
	avatar: (state: any) => state.user.avatar,
	nickname: (state: any) => state.user.name,
	welcome: (state: any) => state.user.welcome,
	roles: (state: any) => state.user.roles,
	snapToken: (state: any) => state.user.snapshotToken,
	userInfo: (state: any) => state.user.userInfo,
	addRouters: (state: any) => state.permission.addRouters,
	multiTab: (state: any) => state.app.multiTab,
	isSysadmin: (state: any) => state.user.userInfo.level === 1,
}

export default getters
